import { Component } from 'react'

export default class Admin extends Component {
  componentWillMount() {
    this.onMount(this.props)
  }
  componentWillReceiveProps(nextProps) {
    this.onMount(nextProps)
  }
  onMount = props => {
    const { isAdmin, goHome } = props
    // Redirect user if required
    if (!isAdmin) {
      goHome()
    }
  }
  render() {
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Admin.js